import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { BUSINESS } from "../lib/constants";

const BookingCTA = ({ variant = "dark", testid = "booking-cta-section" }) => {
    const { t } = useLanguage();
    const isDark = variant === "dark";

    return (
        <section
            data-testid={testid}
            className={`relative overflow-hidden ${isDark ? "bg-[#3D3D24] text-[#FFFFF3]" : "bg-[#FFFFF3] text-[#3D3D24]"}`}
        >
            <div className="max-w-[1100px] mx-auto px-6 py-24 md:py-32 text-center">
                <div className={`font-label text-[11px] mb-6 ${isDark ? "text-[#D4A95A]" : "text-[#D4A95A]"}`}>
                    {t.home.reviewsOverline}
                </div>
                <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] mb-6">
                    {t.home.ctaSectionTitle}
                </h2>
                <p className={`text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10 ${isDark ? "opacity-85" : "opacity-80"}`}>
                    {t.home.ctaSectionBody}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 items-center justify-center">
                    <Link
                        data-testid={`${testid}-book-btn`}
                        to="/contact"
                        className="bg-[#D4A95A] text-[#3D3D24] px-10 py-4 font-label text-xs hover:bg-[#FFFFF3] transition-colors"
                    >
                        {t.common.bookNow}
                    </Link>
                    <a
                        data-testid={`${testid}-call-btn`}
                        href={`tel:${BUSINESS.phoneRaw}`}
                        className={`border px-10 py-4 font-label text-xs transition-colors ${isDark ? "border-[#FFFFF3]/40 text-[#FFFFF3] hover:bg-[#FFFFF3] hover:text-[#3D3D24]" : "border-[#3D3D24] text-[#3D3D24] hover:bg-[#3D3D24] hover:text-[#FFFFF3]"}`}
                    >
                        {BUSINESS.phone}
                    </a>
                </div>
                <div className={`mt-6 text-[11px] font-label tracking-[0.2em] ${isDark ? "opacity-60" : "opacity-65"}`}>
                    {t.common.depositNote}
                </div>
            </div>
        </section>
    );
};

export default BookingCTA;
